import { useHistory, Link } from "react-router-dom";
import NavigateBackWizardStep from "../components/navigateBackWizardStep";
import UpcomingAppointmentView from "./appointment/upcomingAppointmentView";
import { useEffect, useState } from "react";
import PastAppointmentView from "./appointment/pastAppointmentView";
import { useTranslation } from "react-i18next";
import createPersistedState from "use-persisted-state";

const useClinicState = createPersistedState("clinic");

function MyAppointmentsPage({ setId, setIsReschedule, setAttendDetail }) {
  let history = useHistory();
  const [upcomingClassName, setUpcomingClassName] = useState("nav-link active");
  const [pastClassName, setPastClassName] = useState("nav-link");
  const [currentTab, setCurrentTab] = useState("upcoming");
  const { t } = useTranslation();
  const [clinicId, setClinic] = useClinicState();

  useEffect(() => {
    setIsReschedule(false);
  }, []);

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={() => history.push("/my-clinic")}
        title={t("appointment.UPCOMING-APPOINTMENT.topHeading")}
      />
      <div className="body_content p-0">
        <div className="inner_body ">
          <ul className="nav custom_nav_app custom_nav_app_50" id="myTab">
            <li className="nav-item">
              <Link
                to="#"
                onClick={() => {
                  setUpcomingClassName("nav-link active");
                  setPastClassName("nav-link");
                  setCurrentTab("upcoming");
                }}
                className={upcomingClassName}
                data-bs-toggle="tab"
                data-bs-target="#upcoming"
              >
                {t("appointment.UPCOMING-APPOINTMENT.heading1")}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="#"
                onClick={() => {
                  setUpcomingClassName("nav-link");
                  setPastClassName("nav-link active");
                  setCurrentTab("past");
                }}
                className={pastClassName}
                data-bs-toggle="tab"
                data-bs-target="#past"
              >
                {t("appointment.UPCOMING-APPOINTMENT.heading2")}
              </Link>
            </li>
          </ul>
          <div className="custom_tc_app tab-content p-3" id="myTabContent">
            <div
              className="custom_tp_app tab-pane fade show active"
              id="upcoming"
            >
              <div className="row">
                <div className="col-12 mb-4">
                  {currentTab === "upcoming" ? (
                    <UpcomingAppointmentView
                      setId={setId}
                      setIsReschedule={setIsReschedule}
                      setAttendDetail={setAttendDetail}
                    />
                  ) : (
                    <PastAppointmentView />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MyAppointmentsPage;
